import { Component } from '@angular/core';

@Component({
  selector: 'app2',
  templateUrl: './app2.component.html'
})
export class App2Component {
  items = [
      {
          size: { x: 1, y: 1, z: 1 },
          position: { x: 0, y: 0, z: 0 },
          color: "#ff9900"
      },
      {
          size: { x: 1, y: 1, z: 1 },
          position: { x: 0, y: 0, z: 0 },
          color: "#ff9900"
      }
  ];

  ngOnInit() {
    if (window['x3dom']) { window['x3dom'].reload(); }
  }

  add() {
    this.items.push({
        size: { x: 1, y: 1, z: 1 },
        position: { x: 0, y: 0, z: 0 },
        color: "#ff9900"
    });
  }

  remove(index) {
    this.items.splice(index, 1);
  }
}